import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";


const headersCryptoApi = {
    'x-bingapis-sdk': 'true',
    'x-rapidapi-host': 'bing-news-search1.p.rapidapi.com',
    'x-rapidapi-key': '6702e24fa6msh192df11759566bbp1232f5jsn1096fa669d01'
  }

const baseUrl = "https://bing-news-search1.p.rapidapi.com";

const createRequest = (url: string) => ({ url, headers: headersCryptoApi })

export const newsApi = createApi({
    reducerPath: "newsApi",
    baseQuery: fetchBaseQuery({ baseUrl }),
    endpoints: (build) => ({
        getNews: build.query({
            query: () => createRequest(`/news/search?q=crypto`)
        })
    })
});